
const _BASE_URL = "https://hackathon.futnet.id/api/admin/"

export default {
    _BASE_URL
}


// WEBPACK FOOTER //
// ./src/utils/constant.js